import {Component, inject, signal} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthService} from '../../services/AuthService';
import {ApiUserLoginResponse} from '../api/model/apiUserLoginResponse';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {LayoutService} from '../../services/LayoutService';
import {RegistryService} from '../../services/RegistryService';
import {ProgressSpinner} from 'primeng/progressspinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    ReactiveFormsModule,
    Button,
    InputText,
    ProgressSpinner,
  ],
})
export class LoginComponent {
  private auth = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private registry = inject(RegistryService);
  private fb = inject(FormBuilder);
  public layoutService = inject(LayoutService);

  public loginForm = this.fb.group({
    phone: ['', [Validators.required]],
    rememberMe: [false]
  });

  public loading = signal(false);

  constructor() {
    const data = this.route.snapshot.data;
    if (data.hasOwnProperty('logout')) {
      this.auth.logout();
      this.router.navigateByUrl('/login').then(() => {
      })
    }
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }

    this.loading.set(true);
    const {phone} = this.loginForm.getRawValue();

    this.auth.login(phone!).subscribe({
      next: (r: ApiUserLoginResponse) => {
        if (r.token) {
          localStorage.setItem('bisi-token', r.token);
          this.auth.bisiToken.set(r.token);
          if (r.user) {
            this.auth.currentUser.set(r.user);
          } else {
            this.auth.loadUser();
          }
          this.registry.loadServices().catch();
          this.router.navigateByUrl('/dashboard');
        } else {
          this.loading.set(false);
        }
      },
      error: () => {
        this.loading.set(false);
        this.auth.logout();
        alert("Login failed")
      }
    });
  }
}
